import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { SKIP_GLOBAL_ERROR_TOAST } from '../helpers/http-context.tokens';

export interface StampCustomerOrder {
  _id: string;
  orderId: string;
  stateName?: string | null;
  totalStampValue?: number;
  denomination?: number;
  stampLoss?: number;
  stampIds?: string[];
  createdAt?: string;
  [key: string]: unknown;
}

export interface StampCustomerOrdersResponse {
  data: StampCustomerOrder[];
  meta: {
    total: number;
  };
  totalCount: number;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class EStampService {

  constructor(private http: HttpClient) { }

  getStates() {
    return this.http.get<any>('/bulk-estamp/state-list').pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.data.length
      })));
  }

  getOrders(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`/estamp/orders`, { params }).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }
  getStampOrders(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get<StampCustomerOrdersResponse>(`/bulk-estamp/client/orders`, { params }).pipe(
      map((res) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }

  getStampOrderDetail(orderId: any) {
    return this.http.get(`/bulk-estamp/client/orders/${orderId}`);
  }

  getInventoryList(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`/bulk-estamp/client/scanned-stamps`, { params }).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }

  getBulkOrders(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`/bulk-estamp/client/stamp-requests`, { params }).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }

  createOrder(
    orderData: any,
    showInlineError: boolean = false
  ) {
    const data = this.jsonToFormData(orderData)
    return this.http.post('/bulk-estamp/order', data, {
      context: new HttpContext().set(
        SKIP_GLOBAL_ERROR_TOAST,
        showInlineError
      )
    });
  }

  paymentSubmit(paymentData: any) {
    const data = this.jsonToFormData(paymentData)
    return this.http.post('/estamp/payment-proof', data);
  }

  bulkPaymentSubmit(paymentData: any, orderId: any) {
    const data = this.jsonToFormData(paymentData)
    return this.http.post(`/bulk-estamp/stamp-requests/${orderId}/payment-proof`, data);
  }

  jsonToFormData(payload: any) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (value instanceof File) {
        formData.append(key, value);
      }
      else if (typeof value === 'object' && value !== null) {
        formData.append(key, JSON.stringify(value));
      }
      else {
        formData.append(key, value);
      }
    });
    return formData;
  }

  getOrderDetail(orderId: any) {
    return this.http.get(`/estamp/order/${orderId}`);
  }

  getBulkOrderDetail(orderId: any) {
    return this.http.get(`/bulk-estamp/client/stamp-request/${orderId}`);
  }

  // createBulkOrder(orderData: any) {
  //   const data = this.jsonToFormData(orderData);
  //   return this.http.post('/estamp/bulk-order', data);
  // }

  uploadBulkOrdersExcel(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post('/bulk-estamp/stamp-requests/upload', formData);
  }

  downloadBulkOrderTemplate() {
    return this.http.get('/estamp/bulk-order/template', { responseType: 'blob' });
  }

}
